import { render, staticRenderFns } from "./TarjetaTab.vue?vue&type=template&id=a654bf86"
import script from "./TarjetaTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TarjetaTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports